import { useEffect } from 'react';
import useJuryStore from '../../../store/juryStore';

/**
 * Thin hook that triggers the one-time data fetch and exposes the store.
 * Components can also import useJuryStore directly for fine-grained subscriptions.
 */
function useJuryData() {
    const fetchData = useJuryStore((s) => s.fetchData);

    useEffect(() => {
        fetchData();
    }, [fetchData]);
}

export default useJuryData;
